import React from "react";
import PropTypes from "prop-types";
import Background from "../components/common/Background";
import { Card, Col, Row, Container } from "react-bootstrap";
import LogoLogin from "../components/common/LogoLogin";
import Flex from "../components/common/Flex";

const AuthSplitLayout = ({ children, bgProps }) => {
  return (
    <Container fluid>
      <Row className="min-vh-100 bg-white p-5">
        <Col sm={10} md={6} className="px-sm-0 align-self-center mx-auto py-5">
          <Row className="g-0 justify-content-center">
            <Col lg={9} xl={8} className="col-xxl-6">
              <Card className="shadow-none">
                <Card.Header className="text-center p-2">
                  <Flex alignItems="center" justifyContent="center">
                    <LogoLogin />
                  </Flex>
                </Card.Header>
                <Card.Body className="p-4">{children}</Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md={6} xs={6} className="d-none d-lg-block position-relative">
          {bgProps && <Background {...bgProps} className={"rounded-5"} />}
        </Col>
      </Row>
    </Container>
  );
};

AuthSplitLayout.propTypes = {
  children: PropTypes.node.isRequired,
  bgProps: PropTypes.shape(Background.propTypes).isRequired,
};

export default AuthSplitLayout;
